import { ITkTopAccordionProps } from "../../../type/componentsType/TkTopAccordion";
import TkAccordion from "../../atoms/TkAccordion";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import "./_style.scss";
import TkTableWithNoLine from "../TkTableWithNoLine";

/**
 * 重要なお知らせを表示するトップアコーディオンコンポーネントです。
 *
 * @param {ITkTopAccordionProps} props - コンポーネントのプロパティ
 * @param {string} props.title - タイトル
 * @param {Array<INotification>} props.notifications - お知らせの配列
 * @param {React.HTMLAttributes<HTMLDivElement>} props.rest - その他のプロパティ
 */
export const TkTopAccordion: React.FC<ITkTopAccordionProps> = (props) => {
  const { title = "重要なお知らせ", notifications, ...rest } = props;

  return (
    <TkAccordion
      {...rest}
      className="tkTopAccordion"
      title={" > " + title}
      titleClassName="tkTopTitle"
      detailClassName="tkTopDetail"
      isShowExpandIcon={false}
    >
      <TkTableWithNoLine
        headList={[]}
        bodyList={notifications?.map((item) => [
          {
            children: <TaskAltIcon className="checkIcon" />,
          },
          {
            children: item.notificationPublishName,
          },
          {
            children: item.notificationTitle,
          },
          {
            children: `${item.notificationRegisterDate ?? ""} ～ ${
              item.notificationPublishLimit ?? ""
            }`,
          },
          {
            children: item.notificationDetail,
            width: "50%",
          },
        ])}
        noDataMessage={"現在、お知らせはありません。"}
      />
    </TkAccordion>
  );
};

export default TkTopAccordion;
